import { httpClient } from '@/services/http/httpClient'

import type { PortfolioProject } from '../getPortfolioProject'

export type GetMyProjectResponse = PortfolioProject & {
  portfolioId: string
}

export const getMyProject = async ({
  projectId,
}: {
  projectId: string
}): Promise<GetMyProjectResponse> => {
  const { data } = await httpClient.get(
    `/projects/portfolio-projects/my-projects/${projectId}`,
  )

  return data
}
